import { useState } from 'react';
import { Link } from 'react-router-dom';
import { usePathname, useRouter } from '@/lib/navigation';
import { Button } from './button';
import { useTranslations } from '@/i18n';
import { Spinner } from '@/components/ui/shadcn-io/spinner';

export default function Sidebar() {
  const pathname = usePathname();
  const router = useRouter();
  const t = useTranslations('navigation');
  const tCommon = useTranslations('common');
  const [isNavigating, setIsNavigating] = useState(false);

  const navigationItems = [
    {
      label: t('myTrips'),
      href: '/',
      icon: '/assets/icons/briefcase.svg',
      isActive: pathname === '/',
    },
    {
      label: t('myApprovals'),
      href: '/approvals',
      icon: '/assets/icons/document-check.svg',
      isActive: pathname === '/approvals',
    },
    // TODO: Reports nav item hidden for now
    // {
    //   label: t('reports'),
    //   href: '/reports',
    //   icon: '/assets/icons/document.svg',
    //   isActive: pathname === '/reports',
    // },
  ];

  return (
    <div className="hidden h-full w-[14.375rem] flex-col items-center overflow-y-auto border-r border-r-[#f1f1f1] bg-[#f9f9f9] px-4 py-6 md:flex">
      {/* Add Trip Button */}
      <div className="mb-4 h-11 w-full">
        <Button
          className="flex h-[2.75rem] flex-shrink-0 flex-grow basis-0 cursor-pointer items-center justify-center gap-1 self-stretch rounded-4xl px-4 py-2.5 text-sm leading-5 font-medium disabled:opacity-50"
          variant="brand"
          size="none"
          disabled={isNavigating}
          onClick={() => {
            setIsNavigating(true);
            router.push('/trips/new');
          }}
        >
          {isNavigating ? (
            <div className="flex items-center gap-2">
              <Spinner variant="circle" className="h-4 w-4" />
              <span className="whitespace-nowrap">{tCommon('loading')}</span>
            </div>
          ) : (
            <>
              <img
                src="/assets/icons/plus.svg"
                alt="Add"
                className="flex items-center justify-center gap-2"
              />
              <span className="whitespace-nowrap">{t('addTrip')}</span>
            </>
          )}
        </Button>
      </div>

      {/* Navigation Items */}
      <div className="flex w-full flex-col">
        {navigationItems.map((item) => (
          <Link
            key={item.href}
            to={item.href}
            className={`flex min-w-[7rem] items-center gap-2 rounded-2xl px-2 py-4 transition-all ${
              item.isActive
                ? 'bg-[#f1f1f1] text-[#000000]'
                : 'text-[#666666] hover:bg-[#f1f1f1] hover:text-[#000000]'
            }`}
          >
            <div className="relative flex h-7 w-7 shrink-0 items-center justify-center">
              <img
                src={item.icon}
                alt={item.label}
                className="max-h-full max-w-full object-contain"
              />
            </div>
            <span className="text-sm leading-5 text-nowrap text-black">{item.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
